import { render } from "./TechIntegration.vue?vue&type=template&id=163bf8d8"
import script from "./TechIntegration.vue?vue&type=script&lang=js"
export * from "./TechIntegration.vue?vue&type=script&lang=js"

import "./TechIntegration.vue?vue&type=style&index=0&id=163bf8d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__